// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.sendmerchant.com/v1';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: `${API_BASE_URL}/auth/login`,
  REGISTER: `${API_BASE_URL}/auth/register`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,
  REFRESH_TOKEN: `${API_BASE_URL}/auth/refresh-token`,
  
  // Menu endpoints
  MENU_ITEMS: `${API_BASE_URL}/menu-items`,
  MENU_ITEM: (id: string) => `${API_BASE_URL}/menu-items/${id}`,
  MENU_CATEGORIES: `${API_BASE_URL}/menu-categories`,
  MENU_CATEGORY: (id: string) => `${API_BASE_URL}/menu-categories/${id}`,
  
  // Order endpoints
  ORDERS: `${API_BASE_URL}/orders`,
  ORDER: (id: string) => `${API_BASE_URL}/orders/${id}`,
  UPDATE_ORDER_STATUS: (id: string) => `${API_BASE_URL}/orders/${id}/status`,
  
  // Merchant profile endpoints
  MERCHANT_PROFILE: `${API_BASE_URL}/merchant/profile`,
  UPDATE_PROFILE: `${API_BASE_URL}/merchant/profile`,
  
  // Analytics endpoints
  SALES_ANALYTICS: `${API_BASE_URL}/analytics/sales`,
  ORDER_ANALYTICS: `${API_BASE_URL}/analytics/orders`,
  CUSTOMER_ANALYTICS: `${API_BASE_URL}/analytics/customers`,
  
  // Reviews endpoints
  REVIEWS: `${API_BASE_URL}/reviews`,
  REVIEW: (id: string) => `${API_BASE_URL}/reviews/${id}`,
  RESPOND_TO_REVIEW: (id: string) => `${API_BASE_URL}/reviews/${id}/respond`,
  
  // Promotions endpoints
  PROMOTIONS: `${API_BASE_URL}/promotions`,
  PROMOTION: (id: string) => `${API_BASE_URL}/promotions/${id}`,
};
